import React from 'react';
import { Dialog, Paragraph, toaster } from 'evergreen-ui';
import { useDeleteDatasourceMutation } from 'Services/api/datasourcesApi';
import { MinimalDialogProps } from 'Shared/types';
import { useNavigate } from 'react-router-dom';
import { ExtendedDatasourceProps } from './utils';

type DialogDatasourceDeleteProps = MinimalDialogProps & ExtendedDatasourceProps

export function DialogDatasourceDelete({ isShown, datasource, onClose }: DialogDatasourceDeleteProps) {
  const navigate = useNavigate();
  const [deleteDatasourceMutation, { isLoading: isDeleting }] = useDeleteDatasourceMutation();

  const closeDialog = () => onClose(false);

  const deleteDatasource = () => {
    deleteDatasourceMutation(datasource.id)
      .unwrap()
      .then(() => {
        toaster.success('Источник удален');
        closeDialog();
        navigate('/stations'); // TODO: временная переадресация пока нет типов у вебсокета
      })
      .catch(() => {
        closeDialog();
      });
  };

  if (!isShown) return null;
  return (
    <Dialog
      isShown
      title="Удалить источник"
      intent="danger"
      onCloseComplete={closeDialog}
      confirmLabel="Удалить"
      onConfirm={deleteDatasource}
      cancelLabel="Отмена"
      isConfirmLoading={isDeleting}
    >
      <>
        <Paragraph>
          <b>id: </b>
          {datasource?.id}
        </Paragraph>

        {datasource?.serialNum && (
          <Paragraph>
            <b>Серийный номер: </b>
            {datasource.serialNum}
          </Paragraph>
        )}

        <Paragraph>
          <b>Название: </b>
          {datasource.datasourceTypeShortName}
        </Paragraph>
      </>
    </Dialog>
  );
}
